
import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import OtpVerification from "subscreens/general/otpverification/OtpVerification";
import AppContext from "context/AppContext";

function SellerOtpVerification() {
    const { baseUrl, Navigate, authToken } = useContext(AppContext);
    const location = useLocation();
    const [email] = useState(location.state?.email || "");
    // OTP verification ka purpose check karein
    const otpPurpose = location.state?.from || "signup";
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    // ==========================
    // VERIFY OTP
    // ==========================
    const handleVerify = (otp) => {
        setLoading(true);
        axios.post(
            `${baseUrl}/seller/otp/verifyOtp`,
            {
                email: email,
                otp: otp,
                purpose: otpPurpose
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
            .then((response) => {
                if (response.data.success === true) {
                    Swal.fire({
                        icon: "success",
                        title: "Verified!",
                        text: "Your OTP has been verified successfully.",
                        confirmButtonColor: "#000000",
                    }).then(() => {

                        // ==========================
                        // SIGNUP FLOW
                        // ==========================
                        if (otpPurpose === "signup") {
                            Navigate("/seller/login");
                        }

                        // ==========================
                        // FORGOT PASSWORD FLOW
                        // ==========================
                        else if (otpPurpose === "forgot-password") {
                            Navigate("/seller/reset-password", {
                                state: {
                                    email: email,
                                    resetToken: response.data.reset_token,
                                },
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Verification Failed",
                        text:
                            response?.data?.message ||
                            "The code you entered is incorrect or expired.",
                        confirmButtonColor: "#000000",
                    });
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Something went wrong.",
                    confirmButtonColor: "#000000",
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };
    // ==========================
    // RESEND OTP
    // ==========================
    const handleResend = () => {
        setResendLoading(true);
        axios.post(
            `${baseUrl}/seller/otp/resendOtp`,
            {
                email: email,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
            .then((response) => {
                Swal.fire({
                    icon: "success",
                    title: "Code Sent",
                    text:
                        response.data.message ||
                        "A new OTP has been sent to your email.",
                    confirmButtonColor: "#000000",
                    timer: 1800,
                    showConfirmButton: false,
                });
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Couldn't Resend",
                    text:
                        error?.response?.data?.message ||
                        "Please try again shortly.",
                    confirmButtonColor: "#000000",
                });
            })
            .finally(() => {
                setResendLoading(false);
            });
    };
    return (
        <OtpVerification
            email={email}
            userType="seller"
            handleVerify={handleVerify}
            handleResend={handleResend}
            loading={loading}
            resendLoading={resendLoading}
        />
    );
}
export default SellerOtpVerification;